import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { websiteDevelopmentAravalliConfig } from './servicePageConfigs';

const WebsiteDevelopmentAravalli = () => (
  <ServicePageTemplate {...websiteDevelopmentAravalliConfig} />
);

export default WebsiteDevelopmentAravalli;
